import React, { useState } from 'react';

const navLinks = [
  { href: '#skills', label: 'Skills' },
  { href: '#it-projects', label: 'IT Projects' },
  { href: '#ux-projects', label: 'UX Projects' },
  { href: '#contact', label: 'Contact' },
];

const LINKEDIN = 'https://www.linkedin.com/in/liuweiluo/';

export default function Navigation() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 bg-[#0062AD] border-b-2 border-[#FBF0DC]/35">
      <div className="flex items-center justify-between px-[clamp(20px,5vw,72px)] py-5">
        <a href="#top" className="text-lg font-extrabold tracking-tight">
          Liuwei Luo
        </a>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-7">
          {navLinks.map((link) => (
            <a key={link.href} href={link.href} className="text-sm font-semibold">
              {link.label}
            </a>
          ))}
          <a href={LINKEDIN} target="_blank" rel="noopener noreferrer">
            <button type="button" className="btn btn-primary">Get in touch</button>
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          type="button"
          className="md:hidden -mr-2 p-2 text-[#FBF0DC]"
          onClick={() => setMenuOpen((open) => !open)}
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {menuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile dropdown */}
      {menuOpen && (
        <div className="md:hidden flex flex-col gap-4 px-[clamp(20px,5vw,72px)] pb-5">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-semibold"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a href={LINKEDIN} target="_blank" rel="noopener noreferrer">
            <button type="button" className="btn btn-primary w-full">Get in touch</button>
          </a>
        </div>
      )}
    </nav>
  );
}
